import { useCallback } from 'react';
import { useNavigation } from '@react-navigation/native';

export const useRequestLogin = () => {
  const navigation = useNavigation();

  const requestLogin = useCallback(() => {
    navigation.navigate('Auth', {
      screen: 'Login',
      params: { redirect: 'bag' },
    });
  }, [navigation]);

  return { requestLogin };
};
